let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kL6EC")).then(() => parcelRequire('gOpw9'));